var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.01,
    height: 25.336,
    viewBox: "0 0 22.01 25.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    d: "M353.4,186.925a1,1,0,1,1-1-1A1,1,0,0,1,353.4,186.925Z",
    transform: "translate(-341.395 -170.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    d: "M352.4,176.28a3.677,3.677,0,0,0-3.678,3.679h0a1,1,0,1,0,2,0,1.679,1.679,0,1,1,1.679,1.679,1,1,0,0,0-1,1v1.072a1,1,0,0,0,2,0v-.21a3.68,3.68,0,0,0-1-7.221Z",
    transform: "translate(-341.395 -171.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    d: "M341.755,175.816v13.3a4.355,4.355,0,0,0,4.359,4.358h11.841l4.156,3.117a1.034,1.034,0,0,0,1.654-.827V175.816a4.355,4.355,0,0,0-4.358-4.358H346.114A4.356,4.356,0,0,0,341.755,175.816Zm2.069,0a2.288,2.288,0,0,1,2.29-2.289h13.294a2.287,2.287,0,0,1,2.29,2.289v17.874l-2.777-2.083a1.04,1.04,0,0,0-.62-.207H346.114a2.287,2.287,0,0,1-2.29-2.289Z",
    transform: "translate(-341.755 -171.458)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionWhite);
export default __webpack_public_path__ + "static/media/question-white.3da1e4e6ab137a37968aa7e4663cde37.svg";
export { ForwardRef as ReactComponent };